import React, { useState, useEffect } from 'react';

const GemsValue = () => {
  const [activatedId, setActivatedId] = useState(null);
  const hashToId = {
    citrine: 0,
    chrysolite: 1,
    sapphire: 2,
    amethyst: 3,
    ruby: 4,
  };
  useEffect(() => {
    const handleHash = () => {
      const hash = window.location.hash.slice(1).toLowerCase();
      if (hashToId[hash] !== undefined) {
        setActivatedId(hashToId[hash]);
      } else if (hash === 'brief-description' || hash === '') {
        setActivatedId(null);
      }
    };
    handleHash();
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);
  let gemsInfo = [
    {
      id: 0,
      title: 'Citrine',
      commonInfo: `Most citrines on the market are fired amethysts. The purple variety of quartz is more common and, therefore, much less expensive. Therefore, amethyst crystals are often heat-treated to pass them off as more expensive citrines. When heated, the color changes from purple to yellowish-brown.`,
      addInfo: `
Natural gem-quality citrines are quite rare. However, they are inexpensive. The price increases with the size of the crystal. A small stone can be purchased for $5 per carat. Large, high-quality specimens suitable for rings, signet rings, and pendants are valued significantly higher.`,
    },
    {
      id: 1,
      title: 'Chrysolite',
      commonInfo: `Chrysolite is a sought-after and highly prized gemstone. Olivines of intense green and golden-greenish hues are particularly striking. The highest-quality gemstones are olive-green and emerald in color, with no yellow or brown tint. Cat's eye peridot and star peridot are the most valuable.`,
      addInfo: `
Although the mineral olivine is widespread on Earth, gem-quality chrysolites are rare, explaining their high price. Small, low-quality crystals can be purchased for $50-$100. Large, high-quality crystals fetch thousands of dollars, and those over 20 carats can fetch over $10,000.`,
    },
    {
      id: 2,
      title: 'Sapphire',
      commonInfo: `A number of factors influence a specimen's value, but the determining factors are its color tone and transparency. Blue sapphires are the most coveted among fashionistas. In fact, blue stones were originally called true sapphires. Consequently, they are the most expensive.`,
      addInfo: `
Only natural sapphires are highly valued. Low-quality gemstones can be purchased for anywhere from a few dozen to a couple of hundred dollars. Average-quality ones can cost up to $5,000. However, it's easy to stumble upon a fake or imitation gemstone. Since 1910, synthetic sapphires of perfect quality, a variety of colors, and virtually unlimited sizes have been produced.`,
    },
    {
      id: 3,
      title: 'Amethyst',
      commonInfo: `Natural amethyst is a Group 1 gemstone of the 4th order. Compared to precious stones, its value is low. However, its price depends on the quality and color of the individual crystal.`,
      addInfo: ` The average price for a small, light-colored stone is $10 per carat. As the color becomes more intense, the price increases two-threefold or more. Larger specimens are considerably more expensive.`,
    },
    {
      id: 4,
      title: 'Ruby',
      commonInfo: `Ruby is an extremely valuable and rare gemstone. It is one of five minerals classified as Tier I (highest) precious stones. Throughout human history, it was valued more highly than diamonds, only losing its preeminence in the 20th century.`,
      addInfo: `Price depends on many factors, such as color, clarity, cut quality, size, and origin. The most valuable rubies are those of "pigeon's blood" color—a rich red with a slight violet or blue tint. The best stones are of Burmese origin.`,
    },
  ];
  const handleToggle = (id) => {
    setActivatedId(activatedId === id ? null : id);
  };
  const isOpen = (id) => activatedId === id;
  const activeGem = gemsInfo.find((gem) => isOpen(gem.id));
  return (
    <section
      id='brief-description-nav'
      style={{ padding: '20px', backgroundColor: 'black' }}
    >
      <h2 style={{ textAlign: 'center', margin: '40px 0px', color: 'white' }}>
        Brief Description
      </h2>
      <div id='brief-description'>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '10px',
            overflowX: 'auto',
            flexWrap: 'nowrap',
            marginBottom: '20px',
            borderBottom: '1px solid #ddd',
          }}
        >
          {gemsInfo.map((gem) => {
            const isActive = isOpen(gem.id);
            const gemId = gem.title.toLowerCase();
            return (
              <button
                key={gemId}
                onClick={() => handleToggle(gem.id)}
                id={gemId}
                style={{
                  padding: '10px 15px',
                  background: isActive ? '#a1e1ff' : '#ffffff',
                  cursor: 'pointer',
                  border: 'none',
                  borderRadius: '5px 5px 0 0',
                  minWidth: '120px',
                  fontSize: 'inherit',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '8px',
                }}
                aria-expanded={isActive}
              >
                <span style={{ flex: 1 }}>{gem.title}</span>
              </button>
            );
          })}
        </div>
        {activeGem && (
          <div
            style={{
              width: '100%',
              border: '1px solid #ddd',
              borderTop: 'none',
              borderRadius: '0 0 5px 5px',
              padding: '20px',
              color: 'white',
              background: '#000000',
              transition: 'opacity 0.3s ease-in-out',
            }}
          >
            <h3 style={{ marginTop: 0 }}>{activeGem.title}</h3>
            <p>{activeGem.commonInfo}</p>
            <p>{activeGem.addInfo}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default GemsValue;
